import {
  CustomTabList,
  SectionCard,
  SectionCardSubTitle,
  SectionCardTitle,
} from "@/components";
import { Tabs, TabsContent } from "@/components/ui";
import { poultrySlides, shrimpSlides,fishSlides,ruminantSlides, snailSlides, tabs } from "./consts";
import { ProductSlider } from "./ProductSlider";

const OurProducts = () => {
  return (
    <section className="bg-linear-to-r from-blue-50 to-green-100">
      <SectionCard className="flex flex-col items-center justify-center">
        <SectionCardSubTitle>Our Solutions</SectionCardSubTitle>
        <div className="mt-5 text-center">
            <SectionCardTitle className="text-center">
              We provide best Services for <br/> your Animal Health
            </SectionCardTitle>
        </div>
        <Tabs defaultValue="1" className="mt-6 flex items-center">
          <CustomTabList tabs={tabs}/>
          <TabsContent value="1">
            <ProductSlider slides={shrimpSlides} />
          </TabsContent>
          <TabsContent value="2">
            <ProductSlider slides={fishSlides} />
          </TabsContent>
          <TabsContent value="3">
            <ProductSlider slides={poultrySlides} />
          </TabsContent>
          <TabsContent value="4">
            <ProductSlider slides={ruminantSlides} />
          </TabsContent>
          <TabsContent value="5">
            <ProductSlider slides={snailSlides} />
          </TabsContent>
        </Tabs>
      </SectionCard>
    </section>
  );
};

export default OurProducts;
